export enum EmailAddressField {    
    To = 1,
    Cc = 2,
    Bcc = 3
}